import AmazonEBaySetup from "@/components/setup/AmazonEBaySetup.vue";
import SetupBase from "@/components/setup/SetupBase.vue";
import DDPThirdPartCode from "@/components/setup/DDPThirdPartCode.vue";
import EmailRegistration from "@/components/setup/EmailRegistration.vue";

export default {
  path: "/setup",
  name: "Setup Base",
  component: SetupBase,
  meta: {
    breadcrumb: "setup"
  },
  children: [
    {
      path: "ddp-third-part-code",
      name: "DDPThirdPartCode",
      component: DDPThirdPartCode,
      meta: {
        breadcrumb: "ddp_third_party_code"
      }
    },
    {
      path: "email-registration",
      name: "EmailRegistration",
      component: EmailRegistration,
      meta: {
        breadcrumb: "email_registration_setup"
      }
    },
    {
      path: ":type",
      name: "Setup",
      component: AmazonEBaySetup,
      meta: {
        breadcrumb: "ebay"
      }
    }
  ]
};
